import api from 'controllers/raymanAPI.js';
import React from 'react';

import {Divider} from '@material-ui/core';
import Singletons from 'controllers/Singletons.js';
import ChatMessages from './ChatMessages.js';
import ChatFooter from './ChatFooter.js';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';

const styles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      backgroundColor: theme.palette.background.default
    },
    messages: {
        flexGrow: 1,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        padding: "20px 0 20px 0"
    },
    footer: {
        flexBasis: 80,
        padding: 20,
        backgroundColor: theme.palette.background.paper
    }
  }), {name: "RaymanChat"});
  
function ChannelChat({channelData})
{
    const classes = styles();
    const userToTheRight = Singletons.currentUser.userID;

    const [messages, setMessages] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const addChatItem = React.useCallback((newMessage) => {
        if(newMessage.channelID !== channelData.channelID) return;
        let messagesClone = [...messages];
        messagesClone.unshift(newMessage);
        setMessages(messagesClone);
        // TODO: Resolve send read message
        // Important: take into account that admins can read and write in the group but should not have read notifications if not inside the group...

        // if( !readonly && newMessage.fromUser !== Singletons.currentUser.userID ) 
        // {
        //     Singletons.NotificationsSocket.Send('channels.chat.messages.read', 'module', {channelID: channelID, messages: [newMessage.messageID]});
        // }
    },[messages, channelData.channelID]);

    // const setItemRead = React.useCallback((item) => {
    //     if(item.channelID !== channelID) return;
    //     let messagesClone = [...messages];
    //     for(let i=messagesClone.length - 1;i>=0;i--)
    //     {
    //         if(item.messages.includes(messagesClone[i].messageID))
    //         {
    //             messagesClone[i].read = true;
    //         }
    //     }
    //     setMessages(messagesClone);

    // },[messages, channelID]);

    const updateChatItem = React.useCallback((item) => {
        if(item.channelID !== channelData.channelID) return;
        let messagesClone = [...messages];
        for(let i=messagesClone.length - 1;i>=0;i--)
        {
            if(item.messageID === messagesClone[i].messageID)
            {
                messagesClone[i].content = item.content;
            }
        }
        setMessages(messagesClone);

    },[messages, channelData]);

    React.useEffect(() => {
        async function getChat()
        {
            setMessages([]);
            setLoading(true);
            api.channels.messages.getAll(channelData.channelID)
            .then(async (response) =>
            {
                let messages = await response.json();
                // let readArray = [];
                // if(!readonly)
                // {
                //     for(let index in messages)
                //     {
                //         if(!messages[index].read && messages[index].fromUser !== Singletons.currentUser.userID)
                //         {
                //             readArray.push(messages[index].messageID);
                //         }
                //     }
                //     if(!readonly && readArray.length > 0) Singletons.NotificationsSocket.Send('channels.chat.messages.read', 'module', {channelID: channelID, messages: readArray});
                // }
                setMessages(messages);
                setLoading(false);
            });
        }
        
        getChat();

    }, [channelData] );

    React.useEffect(() => {
        function handleNewChatItem(content, target) {
            if(channelData.users.includes(Singletons.currentUser.userID) && target === 'profile_administrators') return;
            addChatItem(content);
        }

        function handleUpdateChatItem(content, target) {
            if(channelData.users.includes(Singletons.currentUser.userID) && target === 'profile_administrators') return;
            updateChatItem(content);
        }

        // function handleChatItemRead(content, target) {
        //     if(!readonly && target === 'profile_administrators') return;
        //     setItemRead(content);
        // }
        
        Singletons.NotificationsSocket.on('channels.chat.messages.created', handleNewChatItem);
        Singletons.NotificationsSocket.on('channels.chat.messages.updated', handleUpdateChatItem);
        // Singletons.NotificationsSocket.on('channels.chat.messages.read', handleChatItemRead);
        return () => {
            Singletons.NotificationsSocket.off('channels.chat.messages.created', handleNewChatItem);
            Singletons.NotificationsSocket.off('channels.chat.messages.updated', handleUpdateChatItem);
            // Singletons.NotificationsSocket.off('channels.chat.messages.read', handleChatItemRead);
        }
    }, [addChatItem, updateChatItem, channelData]);
    
    return <div className={clsx(classes.root)}>
        <ChatMessages className={classes.messages} loading={loading} messages={messages} channelID={channelData.channelID} userToTheRight={userToTheRight}/>
        <Divider />
        {channelData.closed ? null : <ChatFooter className={classes.footer} channelID={channelData.channelID} />}
    </div>
}

export default ChannelChat;